import { HttpError } from "../types/Error";
import { LiveStream } from "../types/LiveStream";
import { MetaStorePageRequest, MetaTitle } from "../types/MetaStore";
import { PagedResults } from "../types/PagedResults";
import { GetLiveAppStreamingSessionsParameters, GetSessionsParameters, LiveAppStreamingSession, LiveAppStreamingSessionWithSegments, SessionSummary } from "../types/Session";
import useApiClient from "./ApiClient";

const useSessionsService = () => {
    const { get, post } = useApiClient();

    const getSession = async (sessionId: string, userId: string): Promise<SessionSummary> => {
        try {
            const item = await get<MetaTitle>(`/admin/sessions/${userId}/${sessionId}`);
            // Check if the response is an error.
            if ((item as HttpError).errorCode) {
                throw (item as HttpError).description;
            }
            return item as SessionSummary;
        } catch (error) {
            console.error("Error fetching session:", error);
            throw error;
        }
    };

    const getLiveStreams = async (): Promise<LiveStream[]> => {

    //     // Mock the result with [{"Username": "nightaries42","Platform": "twitch"},{"Username": "maple_syrup_ghost","Platform": "twitch"},{"Username": "scratchman23vr","Platform": "youtube"},{"Username": "prodbyroxy","Platform": "twitch"},{"Username": "booinvr","Platform": "twitch"},{"Username": "afkmab0y","Platform": "twitch"},{"Username": "onetapwonder_tabor","Platform": "twitch"},{"Username": "gxgammer_120","Platform": "twitch"},{"Username": "tgamer6830","Platform": "twitch"}].
    //     const mockResult: LiveStream[] = [
    //          {
    //     "platform": "twitch",
    //     "username": "nightaries42"
    // },
    // {
    //     "platform": "youtube",
    //     "username": "scratchman23vr"
    // },
    // {
    //     "platform": "twitch",
    //     "username": "booinvr"
    // },
    // {
    //     "platform": "twitch",
    //     "username": "gxgammer_120"
    // },
    // {
    //     "platform": "twitch",
    //     "username": "cowmanvr"
    // },
    // {
    //     "platform": "twitch",
    //     "username": "onetapwonder_tabor"
    // },
    // {
    //     "platform": "youtube",
    //     "username": "CatVR"
    // },
    // {
    //     "platform": "twitch",
    //     "username": "noahthefattyy"
    // },
    // {
    //     "platform": "youtube",
    //     "username": "Jan Connor"
    // },
    // {
    //     "platform": "youtube",
    //     "username": "Rako"
    // }
    //     ];

    //     // Return the result as a promise.
    //     return Promise.resolve(mockResult);

        try {
            const result = await get<LiveStream[]>(`/admin/LiveAppStreamingSessions/livestreams`);
            // Check if the response is an error.
            if ((result as HttpError).errorCode) {
                throw (result as HttpError).description;
            }
            return result as LiveStream[];
        } catch (error) {
            console.error("Error fetching live streams:", error);
            throw error;
        }
    };

    const searchSessions = async (request: GetSessionsParameters): Promise<PagedResults<SessionSummary>> => {
        try {
            const result = await post<PagedResults<SessionSummary>>(
                `/admin/sessions/search`,
                request
            );

            // Check if the response is an error.
            if ((result as HttpError).errorCode) {
                throw (result as HttpError).description;
            }

            return result as PagedResults<SessionSummary>;
        } catch (error) {
            console.error("Error searching sessions:", error);
            throw error;
        }
    };

    const getLiveAppStreamingSession = async (sessionId: string, userId: string): Promise<LiveAppStreamingSession> => {
        try {
            const item = await get<LiveAppStreamingSession>(`/admin/LiveAppStreamingSessions/${userId}/${sessionId}`);
            // Check if the response is an error.
            if ((item as HttpError).errorCode) {
                throw (item as HttpError).description;
            }
            return item as LiveAppStreamingSession;
        } catch (error) {
            console.error("Error fetching live app streaming session:", error);
            throw error;
        }
    }

    const getLiveAppStreamingSessionWithSegments = async (sessionId: string, userId: string): Promise<LiveAppStreamingSessionWithSegments> => {
        try {
            const item = await get<LiveAppStreamingSessionWithSegments>(`/admin/LiveAppStreamingSessions/v2/${userId}/${sessionId}`);
            // Check if the response is an error.
            if ((item as HttpError).errorCode) {
                throw (item as HttpError).description;
            }
            return item as LiveAppStreamingSessionWithSegments;
        } catch (error) {
            console.error("Error fetching live app streaming session with segments:", error);
            throw error;
        }
    }

    const searchLiveAppStreamingSessions = async (request: GetLiveAppStreamingSessionsParameters): Promise<PagedResults<LiveAppStreamingSession>> => {
        try {
            const result = await post<PagedResults<LiveAppStreamingSession>>(
                `/admin/LiveAppStreamingSessions/search`,
                request
            );

            // Check if the response is an error.
            if ((result as HttpError).errorCode) {
                throw (result as HttpError).description;
            }

            return result as PagedResults<LiveAppStreamingSession>;
        } catch (error) {
            console.error("Error searching live app streaming sessions:", error);
            throw error;
        }
    }

    return { getSession, searchSessions, getLiveAppStreamingSession, getLiveAppStreamingSessionWithSegments, searchLiveAppStreamingSessions, getLiveStreams };
};

export default useSessionsService;